module.exports = __webpack_public_path__ + "static/media/1.c96f2f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/educar/1.jpg
// module id = 482
// module chunks = 0